import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroSequencial extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com sequencial de preferência definido';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return (
            registro.informacaoProcessoSalaSessao && registro.informacaoProcessoSalaSessao.sequenciaPreferencia > -9999
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
